// profile page

import { useContext, useEffect, useState, Fragment } from 'react';
import { useForm, useFieldArray, SubmitHandler, useWatch } from "react-hook-form";
import { useParams, Link } from 'react-router-dom';
import StateContext from '../stateContext';
import axios from 'axios';

export function Profile() {

  // get passed param/page
  const { page } = useParams();

  // get state context
  const { userInfo, createNotification, setPopup } = useContext(StateContext);

  const [ userDetails, setUserDetails ] = useState(undefined);

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: async () => {
      // set csrf tokens
      axios.defaults.xsrfCookieName = 'csrftoken';
      axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
      axios.defaults.withCredentials = true;

      return axios.post(
        '/api/account/get',
        {
          "email": userInfo.email,
          "jwt": userInfo.jwt,
        }
      ).then((response) => {
        if (response.status == 200 && response.data.success == true) {
          if (response.data.results > 0) {

            var results = response.data.result;
            
            // convert flat arrays
            for (var i = 0; i < results["experiences"].length; i++) {
              results["experiences"][i].responsibilities = ( results["experiences"][i].responsibilities || []).map(bullet => ({ value: bullet }))
            }
            
            results["skills"] = ( results["skills"] || []).map(bullet => ({ value: bullet }))
            results["topic_excludes"] = ( results["topic_excludes"] || []).map(bullet => ({ value: bullet }))
            results["desired_roles"] = ( results["desired_roles"] || []).map(bullet => ({ value: bullet }))

            return results;
          } else {
            // no results
            createNotification({
              "status": "error",
              "msg": "Error fetching user profile"
            })
          }
        } else {
          // prompt error 
          createNotification({
            "status": "error",
            "msg": "Error fetching user profile",
          })
        }

        return {};
      })
    }
  });

  const { fields: experiences, append: appendExperience, remove: removeExperience } = useFieldArray({ control, name: `experiences` });
  const { fields: skills, append: appendSkill, remove: removeSkill } = useFieldArray({ control, name: `skills` });
  const { fields: educations, append: appendEducation, remove: removeEducation } = useFieldArray({ control, name: `education` });
  const { fields: topicExcludes, append: appendTopic, remove: removeTopic } = useFieldArray({ control, name: `topic_excludes` });
  const { fields: desiredRoles, append: appendRole, remove: removeRole } = useFieldArray({ control, name: `desired_roles` });

  async function updateUserProfile(userProfileUpdate) {

    // convert arrays back to flat array
    for (var i = 0; i < userProfileUpdate["experiences"].length; i++) {
      userProfileUpdate["experiences"][i].responsibilities = ( userProfileUpdate["experiences"][i].responsibilities || []).map(res => ( res["value"]))
    }

    userProfileUpdate["skills"] = ( userProfileUpdate["skills"] || []).map(skill => (skill.value))
    userProfileUpdate["topic_excludes"] = ( userProfileUpdate["topic_excludes"] || []).map(topic => (topic.value))
    userProfileUpdate["desired_roles"] = ( userProfileUpdate["desired_roles"] || []).map(role => (role.value))

    // update dates to needed format
    for(var x = 0; x < userProfileUpdate.experiences.length; x++) {

      if (typeof(userProfileUpdate.experiences[x].start_date) != "string") {
        userProfileUpdate.experiences[x].start_date = userProfileUpdate.experiences[x].start_date.toISOString("YYYY-MM_DD").split('T')[0]
      }

      if (typeof(userProfileUpdate.experiences[x].end_date) != "string") {
        userProfileUpdate.experiences[x].end_date = userProfileUpdate.experiences[x].end_date.toISOString("YYYY-MM_DD").split('T')[0]
      }
    }

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.patch(
      '/api/account/update',
    {
      "email": userInfo.email,
      "jwt": userInfo.jwt,
      "profileUpdate": userProfileUpdate
    }
    ).then((response) => {
        if (response.status == 200 && response.data.success == true) {
          if (response.data.results > 0) {
            createNotification({
              "status": "success",
              "msg": "User profile updated successfully",
            })
          } else {
            // no results
            createNotification({
              "status": "error",
              "msg": "Error updating user profile",
            })
          }
        } else {
          // prompt error 
          createNotification({
            "status": "error",
            "msg": "Error updating user profile",
          })
        }
    })
  }

  async function manageSubscription() {

    if (["active", "trialing", "past_due", "unpaid", "canceled", "incomplete_expired", "past_due"].includes(userInfo.subscription_status)) {
      // set loading
      setPopup({type: "loading", "msg": "Loading subscription management!"});

      // generate subscription management session
      axios.defaults.xsrfCookieName = 'csrftoken';
      axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
      axios.defaults.withCredentials = true;

      axios.post("/api/subscription/manage",
        {
          email: userInfo.email,
          jwt: userInfo.jwt,
          return_url: window.location.href
        }
      ).then((response) => {
        if (response.status == 200 && response.data.results > 0 && response.data.success == true && response.data.results > 0) {
          // clear popup
          setPopup(undefined)

          // route user to link
          window.location.href = response.data.result;
        } else {
          createNotification({
            "status": "error",
            "msg": "Error redirecting to subscription management",
          })
        }
      })
    } else {
      // prompt user to subscribe
      setPopup({type: "subscribe", "msg": "Become a WorkGuild Premium Member to Generate Resumes!"});
    }
  }

  return (
    <main className="profile">
      <nav className='profile'>
        <Link to="/profile/userDetails" className='profileButton' style={ page.toLowerCase() == "userdetails" ? { backgroundColor: "#10694D", color: "white" } : undefined} >
          <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5ZM11 21L14.1014 20.1139C14.2499 20.0715 14.3241 20.0502 14.3934 20.0184C14.4549 19.9902 14.5134 19.9558 14.5679 19.9158C14.6293 19.8707 14.6839 19.8161 14.7932 19.7068L21.25 13.25C21.9404 12.5597 21.9404 11.4403 21.25 10.75C20.5597 10.0596 19.4404 10.0596 18.75 10.75L12.2932 17.2068C12.1839 17.3161 12.1293 17.3707 12.0842 17.4321C12.0442 17.4866 12.0098 17.5451 11.9816 17.6066C11.9497 17.6759 11.9285 17.7501 11.8861 17.8987L11 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          User Info
        </Link>
        <Link to="/profile/workexperience" className='profileButton' style={ page.toLowerCase() == "workexperience" ? { backgroundColor: "#10694D", color: "white" } : undefined}>
          <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.5 20H5C3.89543 20 3 19.1046 3 18V4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V18C21 19.1046 20.1046 20 19 20H17.5M12 19C13.6569 19 15 17.6569 15 16C15 14.3431 13.6569 13 12 13C10.3431 13 9 14.3431 9 16C9 17.6569 10.3431 19 12 19ZM12 19L12.0214 18.9998L8.82867 22.1926L6.00024 19.3641L9.01965 16.3447M12 19L15.1928 22.1926L18.0212 19.3641L15.0018 16.3447M9 6H15M7 9.5H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Work Experience
        </Link>
        <Link to="/profile/skills" className='profileButton' style={ page.toLowerCase() == "skills" ? { backgroundColor: "#10694D", color: "white" } : undefined}>
          <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.13515 11.189L3.3304 4.38052C2.89291 3.59765 2.67417 3.20621 2.71103 2.88573C2.7432 2.60611 2.8917 2.353 3.1201 2.18852C3.38188 2 3.83029 2 4.72711 2H6.96193C7.29523 2 7.46187 2 7.61135 2.04813C7.74362 2.09073 7.86556 2.16042 7.96939 2.25276C8.08674 2.35712 8.17132 2.5007 8.3405 2.78788L12.0001 9L15.6597 2.78788C15.8289 2.5007 15.9135 2.35712 16.0308 2.25276C16.1347 2.16042 16.2566 2.09073 16.3889 2.04813C16.5383 2 16.705 2 17.0383 2H19.2731C20.1699 2 20.6183 2 20.8801 2.18852C21.1085 2.353 21.257 2.60611 21.2892 2.88573C21.326 3.20621 21.1073 3.59765 20.6698 4.38052L16.8651 11.189M10.5001 14L12.0001 13V18M10.7501 18H13.2501M16.5963 10.9038C19.1347 13.4422 19.1347 17.5578 16.5963 20.0962C14.0579 22.6346 9.94232 22.6346 7.40391 20.0962C4.8655 17.5578 4.8655 13.4422 7.40391 10.9038C9.94231 8.3654 14.0579 8.3654 16.5963 10.9038Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Skills
        </Link>
        <Link to="/profile/education" className='profileButton' style={ page.toLowerCase() == "education" ? { backgroundColor: "#10694D", color: "white" } : undefined}>
          <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 14.5001V11.4945C17 11.315 17 11.2253 16.9727 11.146C16.9485 11.076 16.9091 11.0122 16.8572 10.9592C16.7986 10.8993 16.7183 10.8592 16.5578 10.779L12 8.50006M4 9.50006V16.3067C4 16.6786 4 16.8645 4.05802 17.0274C4.10931 17.1713 4.1929 17.3016 4.30238 17.4082C4.42622 17.5287 4.59527 17.6062 4.93335 17.7612L11.3334 20.6945C11.5786 20.8069 11.7012 20.8631 11.8289 20.8853C11.9421 20.9049 12.0579 20.9049 12.1711 20.8853C12.2988 20.8631 12.4214 20.8069 12.6666 20.6945L19.0666 17.7612C19.4047 17.6062 19.5738 17.5287 19.6976 17.4082C19.8071 17.3016 19.8907 17.1713 19.942 17.0274C20 16.8645 20 16.6786 20 16.3067V9.50006M2 8.50006L11.6422 3.67895C11.7734 3.61336 11.839 3.58056 11.9078 3.56766C11.9687 3.55622 12.0313 3.55622 12.0922 3.56766C12.161 3.58056 12.2266 3.61336 12.3578 3.67895L22 8.50006L12.3578 13.3212C12.2266 13.3868 12.161 13.4196 12.0922 13.4325C12.0313 13.4439 11.9687 13.4439 11.9078 13.4325C11.839 13.4196 11.7734 13.3868 11.6422 13.3212L2 8.50006Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Education
        </Link>
        <Link to="/profile/topicexcludes" className='profileButton' style={ page.toLowerCase() == "topicexcludes" ? { backgroundColor: "#10694D", color: "white" } : undefined}>
          <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 8L14.5 13M14.5 8L9.5 13M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Topic Excludes
        </Link>
        <Link to="/profile/desiredroles" className='profileButton' style={ page.toLowerCase() == "desiredroles" ? { backgroundColor: "#10694D", color: "white" } : undefined}>
          <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 8V5L19 2L20 4L22 5L19 8H16ZM16 8L12 11.9999M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Desired Roles
        </Link>
        <button type="button" 
          className='profileButton' 
          onClick={() => {manageSubscription()}}  
        >
          <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 10H22V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H11M14.5 21L16.525 20.595C16.7015 20.5597 16.7898 20.542 16.8721 20.5097C16.9452 20.4811 17.0147 20.4439 17.079 20.399C17.1516 20.3484 17.2152 20.2848 17.3426 20.1574L21.5 16C22.0523 15.4477 22.0523 14.5523 21.5 14C20.9477 13.4477 20.0523 13.4477 19.5 14L15.3426 18.1574C15.2152 18.2848 15.1516 18.3484 15.101 18.421C15.0561 18.4853 15.0189 18.5548 14.9903 18.6279C14.958 18.7102 14.9403 18.7985 14.905 18.975L14.5 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Manage Subscription
        </button>
      </nav>
      <form style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "10px"
      }} 
      onSubmit={handleSubmit(updateUserProfile)}
      >
        { page.toLowerCase() == "userdetails" ? 
        <>
          <div className="input">
            <label htmlFor="name">Full Name</label>
            <input {...register(`name`, { required: true })} placeholder="Firstname Lastname" />
          </div>
          
          <div className="input">
            <label htmlFor="phone">Phone</label>
            <input id="phone" {...register(`phone`, { required: true, pattern: { value: /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/, message: 'Please enter a valid email address'}})} 
              style={ errors.phone ? {border: "1px solid red"} : undefined}
            />
          </div>
          <div className="input">
            <label htmlFor="email">Email</label>
            <input id="email" {...register(`email`, { required: true, pattern: { value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: 'Please enter a valid email address'}})} 
              style={ errors.email ? {border: "1px solid red"} : undefined}
            />
          </div>
          <div className="input">
            <label htmlFor="location">Location</label>
            <input id="location" {...register(`location`, { required: true })} 
              style={ errors.location ? {border: "1px solid red"} : undefined}
            />
          </div>
          <div className="input">
            <label htmlFor="website">Website</label>
            <input id="website" {...register(`website`)} />
          </div>
          <div className="input">
            <label htmlFor="prof_title">Professional Title</label>
            <input
              {...register(`prof_title`, { required: true, validate: (value) => value.length > 0 })} 
              style={ errors.prof_title ? {border: "1px solid red"} : undefined}
            />
          </div>
          <div className="input">
            <label htmlFor="prof_summary">Professional Summary</label>
            <textarea id="prof_summary" {...register(`prof_summary`, { required: true })} 
              style={ errors.prof_summary ? {"border": "1px solid red", "height": "200px", "resize": 'none'} : {"height": "200px", "resize": 'none'}}
            />
          </div>
        </>
        : undefined }
        { page.toLowerCase() == "workexperience" ? 
          <>
            { experiences.map((workExperience, workExperienceIndex) => (
              <Experience
                workExperienceIndex={workExperienceIndex}
                getValues={getValues}
                removeExperience={removeExperience}
                appendExperience={appendExperience}
                control={control}
                register={register}
                errors={errors}
              />
            ))}
            <button className="next" type="button" onClick={() => {appendExperience(
              {
                "title": "",
                "company": "",
                "end_date": "",
                "location": "",
                "current_position": false,
                "start_date": "",
                "responsibilities": [{value: ""}]
              }
            )}}>Add Experience</button>
          </>
        : undefined }
        { page.toLowerCase() == "education" ? 
        <>
          {
            educations.map((edu, eduIndex) => (
              <div 
                style={{
                  border: "solid #e1e1e1 1px", padding: "10px", borderRadius: "10px", 
                  display: "flex", flexDirection: "column", gap: "10px"
                }}

              >
                <div className="input">
                  <label htmlFor={`education.${eduIndex}.degree`}>Degree</label>
                  <input {...register(`education.${eduIndex}.degree`, { required: true })} />
                </div>
                <div className="input">
                  <label htmlFor={`education.${eduIndex}.institution`}>Institution</label>
                  <input {...register(`education.${eduIndex}.institution`, { required: true })} />
                </div>
                <div className="input">
                  <label htmlFor={`education.${eduIndex}.location`}>Location</label>
                  <input {...register(`education.${eduIndex}.location` )} />
                </div>
                <div className="input">
                  <label htmlFor={`education.${eduIndex}.start_date`}>Start Date</label>
                  <input type="date" {...register(`education.${eduIndex}.start_date`, { required: true, message: "Start date needed!" } )} className='stringInput' />
                </div>
                <div className="input">
                  <label htmlFor={`education.${eduIndex}.end_date`}>End Date</label>
                  <input type="date" {...register(`education.${eduIndex}.end_date` )} />
                </div>
                <button className='delete' type='button' onClick={() => removeEducation(eduIndex)}>Remove Education</button>
              </div>
            ))
          }
          <button className="submit" type="button" onClick={() => {appendEducation(
              {
                "degree": "",
                "institution": "",
                "start_date": "",
                "end_date": "",
                "location": ""
              }
            )}}>Add Education +</button>
        </>
        : undefined }
        { page.toLowerCase() == "skills" ? 
          <div className="scatteredArrayInputContainer">
            {
              skills.map((skill, index) => {
                return (
                  <div key={`skill-${index}`} className='scatteredArrayInput' style={ errors?.skills && errors?.skills[index]?.value ? {border: "2px solid red"} : undefined}>
                    <textarea {...register(`skills.${index}.value`, { required: true, minLength: { value: 2, message: "Desired Role Required!" }})} placeholder="type here" />

                    <button type="button" onClick={() => { removeSkill(index)}} >x</button>
                  </div>
                );
              })
            }
            { skills.length < 20 ? 
              <div className="buttonInput">
                <input placeholder='Enter Skill' />
                <button className="submit" key={"-"} type="button" onClick={(e) => {appendSkill({value: e.target.previousElementSibling.value}); e.target.previousElementSibling.value = "";}}>{`Add`}</button>
              </div>
            : undefined}
          </div>
        : undefined }
        { page.toLowerCase() == "topicexcludes" ? 
        <div className="scatteredArrayInputContainer">
          {
            topicExcludes.map((topic, index) => {
              console.log(topic)
              return (
                <div key={`topic-${index}`} className='scatteredArrayInput' style={ errors?.topic && errors?.topic[index]?.value ? {border: "2px solid red"} : undefined}>
                  <textarea {...register(`topic_excludes.${index}.value`, { required: true, minLength: { value: 2, message: "Topic required!" }})} placeholder="type here" />

                  <button type="button" onClick={() => { removeTopic(index)}} >x</button>
                </div>
              );
            })
          }
          { skills.length < 20 ? 
            <div className="buttonInput">
              <input placeholder='Enter topic to exclude' />
              <button className="submit" key={"-"} type="button" onClick={(e) => {appendTopic({value: e.target.previousElementSibling.value}); e.target.previousElementSibling.value = "";}}>Add</button>
            </div>
          : undefined}
        </div>
        : undefined }
        { page.toLowerCase() == "desiredroles" ? 
        <div className="scatteredArrayInputContainer">
          {
            desiredRoles.map((role, index) => {
              return (
                <div key={`role-${index}`} className='scatteredArrayInput' style={ errors?.desired_roles && errors?.desired_roles[index]?.value ? {border: "2px solid red"} : undefined}>
                  <textarea {...register(`desired_roles.${index}.value`, { required: true, minLength: { value: 2, message: "Desired Role Required!" }})} placeholder="type here" />
                  <button type="button" onClick={() => { removeRole(index)}} >x</button>
                </div>
              );
            })
          }
          { desiredRoles.length < 20 ? 
            <div className="buttonInput">
              <input placeholder='Enter Desired Role' />
              <button className="submit" key={"-"} type="button" onClick={(e) => {appendRole({value: e.target.previousElementSibling.value}); e.target.previousElementSibling.value = "";}}>Add</button>
            </div>
          : undefined}
        </div>
        : undefined }
        <button 
          type='submit' 
          className="submit saveButton"
        >Save</button>
      </form>
    </main>
  )
}

export function Experience({workExperienceIndex, getValues, removeExperience, appendExperience, control, register, errors}) {
  
  const isCurrentPosition = useWatch({
    control,
    name: `experiences.${workExperienceIndex}.current_position`,
    defaultValue: false // 🧠 Crucial: Prevents errors if the index doesn't exist
  });

  return (
    <>
      {
        <section 
          key={`workExperience-${workExperienceIndex}`}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px"
            
          }}
        >
          <div className='input'>
            <label htmlFor={`experiences.${workExperienceIndex}.title`} >Job Title</label>
            <input {...register(`experiences.${workExperienceIndex}.title`, { required: true, minLength: { value: 3, message: "Experience title required!" } })} placeholder='Enter job title...' 
              style={ errors?.experiences != undefined && errors?.experiences[workExperienceIndex]?.title ? {border: "2px solid red"} : undefined} 
            />
          </div>
          <div className='input'>
            <label htmlFor={`experiences.${workExperienceIndex}.company`} >Company Name</label>
            <input {...register(`experiences.${workExperienceIndex}.company`, { required: true, minLength: { value: 4, message: "Company name required!" } })} className='stringInput' placeholder='Company Name' 
              style={ errors?.experiences && errors?.experiences[workExperienceIndex]?.company ? {border: "2px solid red"} : undefined}
            />
          </div>
          <div className='input'>
            <label htmlFor={`experiences.${workExperienceIndex}.location`} >Location</label>
            <input {...register(`experiences.${workExperienceIndex}.location`, { required: true, minLength: { value: 4, message: "Location required!" } })} className='stringInput' placeholder='Location' 
              style={ errors?.experiences && errors?.experiences[workExperienceIndex]?.company ? {border: "2px solid red"} : undefined}
            />
          </div>
          <div className='input'>
            <label htmlFor={`experiences.${workExperienceIndex}.start_date`} >Start Date</label>
            <input type="date" {...register(`experiences.${workExperienceIndex}.start_date`, { required: true, message: "Start date needed!" } )} className='stringInput' 
            style={ errors?.experiences && errors?.experiences[workExperienceIndex]?.start_date ? {border: "2px solid red"} : undefined}
            />
          </div>
          <div className='input'>
            <label htmlFor={`experiences.${workExperienceIndex}.current_position`} >
              Current Position
              <input type="checkbox" {...register(`experiences.${workExperienceIndex}.current_position`)} />
            </label>
          </div>
          { isCurrentPosition == true ? 
            undefined 
            : 
            <div className='input'>
              <label htmlFor={`experiences.${workExperienceIndex}.end_date`} >End Date</label>
              <input type="date" {...register(`experiences.${workExperienceIndex}.end_date`, { required: true })} className='stringInput' 
              style={ errors?.experiences && errors?.experiences[workExperienceIndex]?.end_date ? {border: "2px solid red"} : undefined}/>
            </div>
          }
          <Responsibilities 
            experienceIndex={workExperienceIndex}
            control={control}
            register={register}
            errors={errors}
          />
          <button className="delete" onClick={() => { removeExperience(workExperienceIndex)}} 
            style={{
              width: "100%"
            }}
          >
            Remove Experience
          </button>
        </section>
      }
    </>
  )
}

export function Responsibilities({experienceIndex, control, register, errors}) {

  const { fields: responsibilities, append: appendResponsibility, remove: removeResponsibility } = useFieldArray({ control, name: `experiences.${experienceIndex}.responsibilities` });
  
  return (
    <>
      <h4 style={{textAlign: 'left', display: "flex", gap: "10px", alignItems: 'center'}}>
        <span>Responsibilities</span>
        { responsibilities.length < 4 ? 
          <button className="submit" onClick={() => {appendResponsibility({value: ""})}}>+</button> 
          :
          undefined 
        }
      </h4>
      { responsibilities.map((responsibility, responsibilityIndex) => (
        <div
          style={{
            display: "flex", flexDirection: "row", justifyContent: "space-around"
          }}
        >
          <textarea 
            key={`exp-${experienceIndex}-res-${responsibilityIndex}`}
            rows="3"  
            {...register(`experiences.${experienceIndex}.responsibilities.${responsibilityIndex}.value`, { required: true })} 
            placeholder="Enter work responsibilities"
            style={ errors?.experiences && errors?.experiences[experienceIndex]?.responsibilities[responsibilityIndex]?.value ? 
              {border: "2px solid red", width: "85%", resize: "none"} 
              :
              {width: "85%", resize: "none"}
            }
          />
          <button className="cancel" onClick={() => {removeResponsibility(responsibilityIndex)}}>x</button>
        </div>
      ))}
    </>
  )
}
